// Oxford Cleaners blog post library.
// `published` posts render with full content. `upcoming` posts appear on the
// roadmap section so customers (and search engines) can see what's coming.

export const POSTS = [
  // ──────────────────────────── PUBLISHED ────────────────────────────
  {
    slug: "items-you-didnt-know-you-can-dry-clean",
    status: "published",
    title: "5 Items You Didn't Know You Can Dry Clean",
    excerpt:
      "Most people think dry cleaning is just for suits and dress shirts. The truth? Some of the most-used items in your home benefit from a professional clean even more.",
    date: "2026-02-04",
    author: "Oxford Cleaners",
    category: "Tips & Care",
    image: null,
    useUploadImage: "blog-items-drycleanable.jpg",
    readingMinutes: 4,
    content: [
      {
        type: "p",
        text: "When customers walk through our doors at Ray Rd & 56th St, they almost always come in with the usual: dress shirts, suits, the occasional special-occasion dress. But after 30+ years cleaning garments for East Valley families, we can promise you — there's a long list of items that deserve a professional clean, and most people never bring them in.",
      },
      { type: "h2", text: "1. Comforters and duvets" },
      {
        type: "p",
        text: "Home washers are rarely big enough to fully clean a comforter — and the agitator can break down the fill. We dry clean comforters in a process that protects feathers, down and synthetic fibers, removes dust mites, and leaves them fluffy again.",
      },
      { type: "h2", text: "2. Pillows" },
      {
        type: "p",
        text: "Yes, really. Pillows collect sweat, oils and allergens. A professional clean restores loft and removes the yellowing you can't get out at home — without ruining the fill.",
      },
      { type: "h2", text: "3. Backpacks and lunchboxes" },
      {
        type: "p",
        text: "Especially around Chandler back-to-school season, parents drop these off in droves. Crayon, ketchup, milk — even the inside of an old water-bottle pocket — comes out properly after a dry clean.",
      },
      { type: "h2", text: "4. Halloween and costume pieces" },
      {
        type: "p",
        text: "Polyester, sequins, faux fur, even some 'do not wash' costume tags — we can handle them. A dry clean preserves color and detail so the costume looks new next year.",
      },
      { type: "h2", text: "5. Wedding-related items beyond the dress" },
      {
        type: "p",
        text: "Ring pillows, veil, garter, the groom's tie — we can preserve all of it together with the gown. It makes a beautiful keepsake.",
      },
      { type: "h2", text: "Bring it in — even if you're not sure" },
      {
        type: "p",
        text: "Not sure if your item is dry-clean safe? Bring it by or text us a photo at 480-940-6023. We'll take a look at the fabric care label and let you know for free — no obligation.",
      },
    ],
  },
  {
    slug: "soccer-jersey-stains-chandler-parents",
    status: "published",
    title: "The Chandler Parent's Soccer-Jersey Stain Survival Guide",
    excerpt:
      "Grass, mud, sweat, and the occasional snow-cone disaster. Here's how Chandler parents can keep their kids' uniforms looking like opening day all season long.",
    date: "2026-02-18",
    author: "Oxford Cleaners",
    category: "Family Care",
    image: null,
    useUploadImage: "blog-soccer-jersey.jpg",
    readingMinutes: 5,
    content: [
      {
        type: "p",
        text: "If you've got a kid in soccer in Chandler — whether they're at AYSO, Tumbleweed, or one of the club teams over at Snedigar — you already know the routine. Sunday afternoon, the gear bag hits the laundry room floor, and somewhere in there is a jersey that looks like it lost a fight with the desert.",
      },
      { type: "h2", text: "Rule #1: Treat the stain before it sets" },
      {
        type: "p",
        text: "The longer a stain sits — especially in Arizona heat, which bakes proteins right into the fabric — the harder it is to remove. Rinse cold (never hot) water through the back of the stain as soon as you can. Hot water cooks blood and grass right in.",
      },
      { type: "h2", text: "Rule #2: Skip the bleach on colors" },
      {
        type: "p",
        text: "Bleach destroys the dye and weakens the synthetic fibers most jerseys are made from. A good enzyme pre-treatment is far better. If you're not sure what to use, drop it off and we'll handle it.",
      },
      { type: "h2", text: "Rule #3: Don't dry until the stain is gone" },
      {
        type: "p",
        text: "Once you put a stained item in the dryer, that stain is locked in for life. Inspect everything before it goes in.",
      },
      { type: "h2", text: "When to just bring it to us" },
      {
        type: "p",
        text: "Grass, mud, and sweat we can almost always rescue — even days later. Bring the whole gear bag in and we'll give it the same treatment a pro club uses on their kit. Plus, free pickup means you don't even have to leave the carpool line.",
      },
    ],
  },
  {
    slug: "wedding-gown-care-arizona-heat",
    status: "published",
    title: "Wedding Gown Care in the Arizona Heat: A Local Guide",
    excerpt:
      "Wedding season in the East Valley means dust, dry air, and that one heat wave nobody planned for. Here's how to keep your gown looking flawless from rehearsal to preservation.",
    date: "2026-03-03",
    author: "Oxford Cleaners",
    category: "Wedding",
    image: null,
    useUploadImage: "blog-wedding-gown.jpg",
    readingMinutes: 6,
    content: [
      {
        type: "p",
        text: "Phoenix and Chandler wedding venues are stunning, but the climate does a number on delicate fabrics. Here's what every East Valley bride should know about keeping her dress flawless — from the first try-on to long-term preservation.",
      },
      { type: "h2", text: "Store flat and away from direct sun" },
      {
        type: "p",
        text: "Arizona sunlight will yellow ivory and white silks faster than almost any other climate. Hang the gown in a breathable garment bag, never plastic, and away from any window the sun touches in the afternoon.",
      },
      { type: "h2", text: "Don't try to spot-clean before the ceremony" },
      {
        type: "p",
        text: "Many gown fabrics — silk, organza, beaded chiffon — will water-spot from a single drop. If something splashes day-of, dab with a dry white cloth and leave it for the cleaners afterward.",
      },
      { type: "h2", text: "Preserve within 6 weeks" },
      {
        type: "p",
        text: "Champagne, makeup and sweat all set into fabric over time. The sooner the gown gets to us after the wedding, the better the result. We use an heirloom-grade, acid-free preservation process that protects the dress for decades.",
      },
      { type: "h2", text: "Free preservation consultation" },
      {
        type: "p",
        text: "Bring the gown in — or schedule a free pickup — and we'll give you a written quote based on fabric, beading and storage style. No surprises, no upsells.",
      },
    ],
  },
  {
    slug: "eco-friendly-dry-cleaning-explained",
    status: "published",
    title: "Why Modern Dry Cleaning is Greener Than You Think",
    excerpt:
      "The old-school chemicals are out. Here's what's actually happening behind the counter at a modern, eco-conscious dry cleaner — and why your clothes (and the East Valley) are better for it.",
    date: "2026-03-18",
    author: "Oxford Cleaners",
    category: "Sustainability",
    image:
      "https://images.pexels.com/photos/4099354/pexels-photo-4099354.jpeg?auto=compress&cs=tinysrgb&w=1280",
    readingMinutes: 4,
    content: [
      {
        type: "p",
        text: "If 'dry cleaning' makes you picture a back-room full of harsh chemical smells, you're picturing an industry that doesn't exist anymore — at least not at the small, family-run shops like ours.",
      },
      { type: "h2", text: "Gentler solvents, by design" },
      {
        type: "p",
        text: "Modern dry cleaning uses modern, gentle solvents that work like water for fabrics that hate water. They lift stains without breaking down dyes or fibers, and they leave essentially no chemical residue.",
      },
      { type: "h2", text: "Closed-loop machines" },
      {
        type: "p",
        text: "Our equipment recycles the solvent in a closed loop, capturing nearly all of it for re-use. We use a fraction of the resources a home washer does for the same number of pounds of laundry.",
      },
      { type: "h2", text: "Longer-lasting garments = less waste" },
      {
        type: "p",
        text: "The most sustainable thing you can do with a piece of clothing is wear it longer. Professional cleaning preserves color, fit and fabric integrity — so that great suit lasts 10 years instead of 3.",
      },
    ],
  },
  {
    slug: "veteran-uniform-class-a-care-guide",
    status: "published",
    title: "Caring for Your Military Class A Uniform: A Veteran's Guide",
    excerpt:
      "From inspection-ready creases to ribbon-rack alignment, here's how to keep your Class A looking sharp. Plus — Oxford Cleaners is now offering free Class A cleaning for all veterans.",
    date: "2026-04-01",
    author: "Oxford Cleaners",
    category: "Veterans",
    image: null, // uses /api/uploads/veteran_owner.jpg
    useUploadImage: "veteran_owner.jpg",
    readingMinutes: 5,
    content: [
      {
        type: "p",
        text: "After 10 years in the U.S. Army Reserves, our owner knows exactly what a fresh, inspection-ready Class A is supposed to look like — and how easy it is to ruin one in the wrong washing machine. Here's how to keep yours sharp.",
      },
      { type: "h2", text: "Never put a Class A in the home washer" },
      {
        type: "p",
        text: "Wool and wool-blend uniforms shrink, lose their drape, and lose their shape in a home washing cycle. They're designed to be dry cleaned, period.",
      },
      { type: "h2", text: "Don't iron over insignia or ribbons" },
      {
        type: "p",
        text: "Heat melts the adhesive backing and damages the embroidery. A press should always happen with the insignia and ribbons removed or covered with a press cloth.",
      },
      { type: "h2", text: "Store with proper hangers" },
      {
        type: "p",
        text: "Wire hangers ruin shoulder lines. Always use a broad, contoured wooden or padded hanger, and store in a breathable garment bag — never plastic.",
      },
      { type: "h2", text: "Our promise to fellow veterans" },
      {
        type: "p",
        text: "Oxford Cleaners is now offering free professional cleaning on every U.S. military Class A uniform and every U.S. flag — one of each per customer — as a small thank-you for service. Schedule a free pickup right from our home page.",
      },
    ],
  },
  {
    slug: "pool-chlorine-and-sunscreen-stain-removal",
    status: "published",
    title: "How to Get Pool Chlorine & Sunscreen Out of Your Favorite Clothes",
    excerpt:
      "Two of the most common Arizona summer wardrobe killers — and exactly how to rescue your favorite shirts, swimsuits and cover-ups before the damage sets in.",
    date: "2026-04-15",
    author: "Oxford Cleaners",
    category: "Tips & Care",
    image: null,
    useUploadImage: "blog-pool-chlorine.jpg",
    readingMinutes: 4,
    content: [
      {
        type: "p",
        text: "If you've lived in the East Valley for a summer, you know the routine: pool, sunscreen, snack, repeat. And your clothes pay the price.",
      },
      { type: "h2", text: "Sunscreen: rinse, then enzyme" },
      {
        type: "p",
        text: "Modern sunscreens contain oils and avobenzone, which leaves orange or rust-colored stains as it oxidizes. Rinse in cold water first, then treat with a gentle enzyme cleaner — never bleach on colors. Bring it in if it's already discolored; we have professional solvents that can lift it.",
      },
      { type: "h2", text: "Chlorine: don't wait to rinse" },
      {
        type: "p",
        text: "Chlorine breaks down elastic and dye faster than anything else in your closet. Rinse swimsuits, cover-ups and pool towels in cool, clean water within an hour of getting home — even a quick rinse extends their life by months.",
      },
      { type: "h2", text: "When in doubt, bring it in" },
      {
        type: "p",
        text: "Especially for higher-end swimwear, cover-ups and resort wear, professional cleaning is what keeps them looking new. Our free pickup is the easiest way — drop in your schedule, we grab the bag from your doorstep.",
      },
    ],
  },

  // ──────────────────────────── UPCOMING ────────────────────────────
  // These appear on the blog page in a "Coming up" section, scheduled
  // monthly so customers (and SEO) can see the content calendar.
  {
    slug: "upcoming-spring-closet-refresh",
    status: "upcoming",
    title: "Spring Closet Refresh: 7 Items You Forgot to Dry Clean",
    excerpt:
      "What to pull out of storage, what to send in for a clean, and what to donate before the heat hits.",
    date: "2026-03-15",
    category: "Tips & Care",
  },
  {
    slug: "upcoming-wedding-suit-care",
    status: "upcoming",
    title: "Wedding-Guest Survival: Last-Minute Suit & Dress Care in Chandler",
    excerpt:
      "Wrinkles in the suitcase? Wine on the lapel? Here's our 24-hour rescue plan for the East Valley wedding circuit.",
    date: "2026-04-15",
    category: "Wedding",
  },
  {
    slug: "upcoming-winter-coat-storage",
    status: "upcoming",
    title: "Storing Winter Coats Through Arizona Summers",
    excerpt:
      "Why moths, dust and heat ruin coats in our climate — and the right way to put them away until November.",
    date: "2026-05-15",
    category: "Seasonal",
  },
  {
    slug: "upcoming-linen-and-lightweight-care",
    status: "upcoming",
    title: "Beat the Heat: Caring for Linen, Cotton & Lightweight Suits",
    excerpt:
      "The fabrics that survive a Chandler summer — and the cleaning routine that keeps them looking sharp.",
    date: "2026-06-15",
    category: "Tips & Care",
  },
  {
    slug: "upcoming-4th-of-july-stains",
    status: "upcoming",
    title: "4th of July Stains: BBQ, Watermelon & Sunscreen Survival Guide",
    excerpt:
      "The three most common holiday-weekend stains we see — and how to attack them before Monday.",
    date: "2026-07-01",
    category: "Family Care",
  },
  {
    slug: "upcoming-back-to-school-uniforms",
    status: "upcoming",
    title: "Back-to-School Uniforms: The Chandler Parent's Stain-Proofing Plan",
    excerpt:
      "How to set up your kid's wardrobe for an entire school year of grass, ketchup and marker — without buying new clothes in October.",
    date: "2026-08-01",
    category: "Family Care",
  },
];

export const PUBLISHED_POSTS = POSTS.filter((p) => p.status === "published")
  .slice()
  .sort((a, b) => b.date.localeCompare(a.date));

export const UPCOMING_POSTS = POSTS.filter((p) => p.status === "upcoming")
  .slice()
  .sort((a, b) => a.date.localeCompare(b.date));

export function getPostBySlug(slug) {
  return POSTS.find((p) => p.slug === slug && p.status === "published");
}

export function formatPostDate(iso) {
  try {
    const d = new Date(iso + "T00:00:00");
    return d.toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  } catch {
    return iso;
  }
}

export function getPostImage(post) {
  if (post.useUploadImage) {
    return `${process.env.REACT_APP_BACKEND_URL}/api/uploads/${post.useUploadImage}`;
  }
  return post.image;
}
